import { Popover, Button } from "antd";
import { ReadOutlined } from "@ant-design/icons";
import "./citationFootnote.scss";

export const CitationFootnote = ({ number, citation }) => {
  return (
    <Popover
      content={
        <div style={{ maxWidth: 300 }}>
          <div style={{ fontSize: 13 }}>
            <span>{citation.authors}</span>{" "}
            <span>{citation.title}</span>{" "}
            <span style={{ fontStyle: "italic" }}>{citation.journal}</span>
            <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 6 }}>
              <Button
                type="default"
                size="small"
                href={citation.link}
                target="_blank"
                rel="noopener noreferrer"
                icon={<ReadOutlined />}
                style={{ fontWeight: 500 }}
              >
                View study
              </Button>
            </div>
          </div>
        </div>
      }
      trigger="hover"
    >
      <span className="citation-footnote">
        {number}
      </span>
    </Popover>
  );
}

export default CitationFootnote;